import { useMsal } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import { getUserAndOrganizationData } from '../../Components/Helpers/Schema/Schema';
import PricingForm from '../../Components/Pricing/PricingForm';
import PricingContextProvider from '../../Context/Pricing/PricingContext';

function WorkspacePaymentPage({organization}) {
    return (
        <PricingContextProvider>
            <PricingForm
                organization={organization}
                userRole={organization.roleType}
                isAccessedFromRuntime={true} />
        </PricingContextProvider>
    )
}

export default WorkspacePaymentPage;